module.exports = __webpack_public_path__ + "university-seneca.png?216ef4724db35f47ba76365b3142a640";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/university-seneca.png
// module id = 151
// module chunks = 0